/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Payment_ProcessingInputs */

const en_status_payment_processing = /** @type {(inputs: Status_Payment_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment Processing`)
};

const es_status_payment_processing = /** @type {(inputs: Status_Payment_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando pago`)
};

/**
* | output |
* | --- |
* | "Payment Processing" |
*
* @param {Status_Payment_ProcessingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_payment_processing = /** @type {((inputs?: Status_Payment_ProcessingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Payment_ProcessingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_payment_processing(inputs)
	return es_status_payment_processing(inputs)
});